import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FilterPanel = ({ 
  categories, 
  selectedCategory, 
  onCategoryChange, 
  sortBy, 
  onSortChange,
  isOpen,
  onClose,
  totalPosts = 0
}) => {
  const sortOptions = [
    { value: 'latest', label: 'Latest First', icon: 'ArrowDownWideNarrow' },
    { value: 'oldest', label: 'Oldest First', icon: 'ArrowUpWideNarrow' },
    { value: 'popular', label: 'Most Popular', icon: 'TrendingUp' },
    { value: 'featured', label: 'Featured', icon: 'Star' }
  ];

  return (
    <>
      {/* Mobile Overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}
      {/* Filter Panel */}
      <div className={`
        fixed lg:static inset-y-0 right-0 w-80 bg-card border-l lg:border-l-0 border-border
        transform transition-transform duration-300 z-50 lg:z-0
        ${isOpen ? 'translate-x-0' : 'translate-x-full lg:translate-x-0'}
        overflow-y-auto
      `}>
        <div className="p-4 md:p-5 lg:p-6">
          {/* Mobile Close Button */}
          <div className="flex items-center justify-between mb-6 lg:hidden">
            <h3 className="text-lg font-semibold text-foreground">Filters</h3>
            <button
              onClick={onClose}
              className="p-2 hover:bg-muted rounded-lg transition-colors"
              aria-label="Close filters"
            >
              <Icon name="X" size={20} />
            </button>
          </div>

          {/* Categories */}
          <div className="mb-6">
            <h4 className="text-sm font-semibold text-foreground mb-3 flex items-center gap-2">
              <Icon name="FolderOpen" size={16} />
              Categories
            </h4>
            <div className="space-y-2">
              <button
                onClick={() => onCategoryChange('all')}
                className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-colors ${
                  selectedCategory === 'all' ?'bg-accent text-accent-foreground font-medium' :'text-foreground hover:bg-muted'
                }`}
              >
                <div className="flex items-center justify-between">
                  <span>All Posts</span>
                  <span className="text-xs opacity-70">
                    {totalPosts}
                  </span>
                </div>
              </button>
              {categories?.map((category) => (
                <button
                  key={category?.id}
                  onClick={() => onCategoryChange(category?.id)}
                  className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-colors ${
                    selectedCategory === category?.id
                      ? 'bg-accent text-accent-foreground font-medium'
                      : 'text-foreground hover:bg-muted'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span>{category?.name}</span>
                    <span className="text-xs opacity-70">{category?.count}</span>
                  </div>
                </button>
              ))}
            </div>
          </div>

          {/* Sort Options */}
          <div className="mb-6">
            <h4 className="text-sm font-semibold text-foreground mb-3 flex items-center gap-2">
              <Icon name="ArrowUpDown" size={16} />
              Sort By
            </h4>
            <div className="space-y-2">
              {sortOptions?.map((option) => (
                <button
                  key={option?.value}
                  onClick={() => onSortChange(option?.value)}
                  className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-colors flex items-center gap-2 ${
                    sortBy === option?.value
                      ? 'bg-accent text-accent-foreground font-medium'
                      : 'text-foreground hover:bg-muted'
                  }`}
                >
                  <Icon name={option?.icon} size={16} />
                  <span>{option?.label}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Apply Button (Mobile) */}
          <div className="lg:hidden">
            <Button
              variant="default"
              fullWidth
              onClick={onClose}
            >
              Apply Filters
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterPanel;